export enum EmailFlowType {
  EMAIL_FLOW = 'EMAIL_FLOW',
}

export const isEmailFlow = (flow: { type: EmailFlowType }) =>
  flow.type === EmailFlowType.EMAIL_FLOW;
